import React, {Component} from 'react'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {CHANGE_CUSTOMER_RISK_LEVELS, gaEventWithUserIdLabel, gaPageView, izBlank, izNotBlank, izNotEmpty, LOG_OUT} from "../constants";
import {UserAction} from "../actions/UserAction";
import {message, Spin} from "antd";
import CustomerService from "../services/customer.service";
import i18n from "i18next";
import AuthService from "../services/auth.service";
import Search from "antd/es/input/Search";
import {LoadingOutlined} from "@ant-design/icons";
import CommonService from "../services/common.service";
import {CommonAction} from "../actions/CommonAction";
import CustomerProfileCard from "./CustomerProfileCard";

const antIcon = <LoadingOutlined style={{fontSize: 24}} spin/>;

class CustomerProfile extends Component {

    componentDidMount() {
        gaPageView()

        this.checkCustomerRiskLevels();

        if (this.state.hasCustomerNoFromTx) {
            setTimeout(function () {
                this.customerProfile(this.state.customerNoFromTx);
            }.bind(this), 351);
        }
    }

    constructor(props) {
        super(props)

        const customerNoFromTx = CustomerService.getCustomerNoFromTx();
        const hasCustomerNoFromTx = izNotBlank(customerNoFromTx);

        this.state = {
            customerNoFromTx: customerNoFromTx,
            hasCustomerNoFromTx: hasCustomerNoFromTx,
            customerNoFilter: hasCustomerNoFromTx ? customerNoFromTx : '',
            searching: hasCustomerNoFromTx,
            firstVisit: !hasCustomerNoFromTx,
            startDate: '',
            endDate: '',
        };
    }

    checkCustomerRiskLevels = () => {

        const customerRiskLevels = this.state.customerRiskLevels
        if (izNotEmpty(customerRiskLevels)) return

        CustomerService.riskLevels()
            .then(
                response => {
                    if (response.data && response.data.success === true) {
                        const customerRiskLevels = response.data.items

                        CommonService.saveCustomerRiskLevels(customerRiskLevels)
                        this.props.commonAction(CHANGE_CUSTOMER_RISK_LEVELS, customerRiskLevels)
                    }
                },
                error => {
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    }
                }
            )
    }

    customerProfile = (customerNoFromTx) => {

        let {customerNoFilter} = this.state;

        if (izNotBlank(customerNoFromTx)) customerNoFilter = customerNoFromTx

        if (izBlank(customerNoFilter)) {
            return message.error(i18n.t('error_customerNo'))
        }

        this.setState({searching: true, firstVisit: false})

        CustomerService.profile(customerNoFilter)
            .then(
                response => {

                    if (response.data.success === true) {
                        const {customer, scores, txItems} = response.data

                        setTimeout(function () {
                            this.setState({
                                searching: false,
                                firstVisit: false,
                                customer: customer,
                                scores: scores ? scores : [],
                                txItems: txItems ? txItems : [],
                            });
                        }.bind(this), 351);
                    } else {

                        setTimeout(function () {
                            this.setState({
                                searching: false,
                                firstVisit: false,
                                customer: null,
                                scores: [],
                                txItems: [],
                            });
                            message.error(i18n.t('customerNotFound'));
                        }.bind(this), 351);
                    }
                },
                error => {
                    this.setState({
                        searching: false,
                        firstVisit: false,
                        customer: null,
                        scores: [],
                        txItems: [],
                    })

                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        gaEventWithUserIdLabel("TransactionService.searchCustomer Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }

    handleCustomerNoFilterChange = (e) => {
        let {name, value} = e.target

        if (izBlank(value)) {
            CustomerService.removeCustomerNoFromTx()
            this.setState({
                customer: null,
                firstVisit: true,
                hasCustomerNoFromTx: false,
                [name]: value
            });
        } else {
            this.setState({
                [name]: value
            })
        }
    }

    customerNoFilterSearch = (customerNoFilter) => {
        if (izNotBlank(customerNoFilter)) this.customerProfile()
    }

    render() {
        const {customer, scores, txItems, customerNoFilter, searching, firstVisit} = this.state;

        return (
            <>
                <section className="ms-section pb-20">
                    <div className="container">
                        <div className="row mb-20 custom-ant-select-2 custom-ant-range">

                            <div className="custom-ant-search">
                                <Search
                                    size="large"
                                    name="customerNoFilter"
                                    value={customerNoFilter}
                                    placeholder={i18n.t('customerNoFilter')}
                                    onChange={this.handleCustomerNoFilterChange}
                                    onSearch={this.customerNoFilterSearch}
                                    allowClear
                                    enterButton={i18n.t('search')}
                                />
                            </div>
                        </div>

                        <div className="row justify-content-center pb-25">
                            <div className="customer-profile-container custom-box-shadow custom-card-border">

                                <Spin indicator={antIcon} spinning={searching}>
                                    {customer ?
                                        <CustomerProfileCard customer={customer} scores={scores} txItems={txItems}/>
                                        :
                                        <>
                                            {firstVisit ?
                                                <div className="customer-search-result-count">{i18n.t('customerSearchRequired')}</div>
                                                :
                                                <>
                                                    {searching ?
                                                        <div className="customer-search-result-count">{i18n.t('searching')}</div>
                                                        :
                                                        <div className="customer-search-result-count">{i18n.t('customerProfileNotFound')}</div>
                                                    }
                                                </>
                                            }
                                        </>
                                    }
                                </Spin>

                            </div>
                        </div>

                    </div>
                </section>
            </>
        )
    }

}

function mapStateToProps(state) {
    return {
        user: state.user,
        common: state.common,
        search: state.search
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction,
        commonAction: CommonAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerProfile);